import React from 'react'

type MwFormLabelProps = {
  label: string
  required?: boolean
  children: React.ReactNode
}

const MwFormLabel: React.FC<MwFormLabelProps> = ({ label, children, required = true }) => {
  return (
    <li>
      <label className={!required ? 'unrequire' : ''}>{label}</label>
      <div className="w-full pc:flex">{children}</div>
    </li>
  )
}

export default MwFormLabel
